import React, { useState } from 'react';
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
// import { Tab, Tabs } from '@mui/material';
import { styled, Box } from "@mui/system";
import "./MoveProductModal.scss";
import { MenuItem, Select, FormControl } from '@mui/material';
import {
  transferInventoryReservation,
} from "../../../services/utilsProductInventory";
import CircularProgress from '@mui/material/CircularProgress';



const MoveProductModal = ({ isOpen, onClose, salePointData, salePoints, selectedModalSalePoint, onModalSalePointChange, modalQuantity, onQuantityChange }) => {
  const [activeTab] = useState('transfer');

  const BlueButton = styled(Button)(({ theme }) => ({
    backgroundColor: '#01A532',
    '&:hover': {
      backgroundColor: '#005d84',
    },
  }));

  // const data = salePointData

  const [quantity, setQuantity] = useState('');
  const [warningMessage, setWarningMessage] = useState("");
  // const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showResultModal, setShowResultModal] = useState(false);
  const [resultMessage, setResultMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // const [confirmationStatus, setConfirmationStatus] = useState({
  //   success: false,
  //   message: ''
  // });

  const handleSave = () => {
    if (!quantity || !selectedModalSalePoint) {
      alert("Por favor, completa todos los campos.");
      return;
    }

    setShowConfirmModal(true);
  };


  const handleConfirmTransfer = async () => {
    setShowResultModal(false);
    setIsLoading(true);

    const transferData = {
      fk_product: salePointData.selectedId,
      fk_sale_point_source: salePointData.sale_point_id,
      fk_sale_point_destination: selectedModalSalePoint,
      quantity: Number(quantity),
      reservation_date: salePointData.selectedDate,
    };

    try {
      const response = await transferInventoryReservation(transferData);

      const productName = salePointData?.name || "Producto desconocido";
      const sourceName = salePointData?.sale_point_name || "Origen desconocido";
      const destinationName = salePoints.find(sp => sp.value === selectedModalSalePoint)?.label || "Destino desconocido";

      if (response.success) {
        setResultMessage(`Se trasladó "${productName}" (${quantity} unidades) del punto de venta "${sourceName}" al punto de venta "${destinationName}" de manera exitosa.`);
      } else {
        setResultMessage(`Falló el traslado de "${productName}" del punto de venta "${sourceName}" al punto de venta "${destinationName}". Motivo: ${response.error || "Error desconocido"}`);
      }
    } catch (error) {
      console.error("Error al transferir inventario:", error);
      setResultMessage(`Error de conexión o del servidor al intentar trasladar "${salePointData?.name}".`);
    } finally {
      setIsLoading(false);
      setShowConfirmModal(false);
      setShowResultModal(true);
    }
  };

  const handleQuantityChange = (event) => {
    const value = parseFloat(event.target.value);
    const maxQuantity = parseFloat(salePointData.current_quantity.replace(/[^0-9.]/g, ''));

    if (value > maxQuantity) {
      setWarningMessage(`La cantidad máxima es ${maxQuantity}`);
    } else {
      setWarningMessage('');
    }

    setQuantity(value);
  };


  const renderTabContent = () => {
    if (activeTab === 'transfer') {
      return (
        <div>
          <div className="modal-title">Traslado de productos</div>

          {/* Resume */}
          <div className="move-summary">
            <div className="move-row">
              <span className="move-label">Cantidad:</span>
              <div className="input-container">
                <input
                  type="number"
                  value={quantity}
                  onChange={handleQuantityChange}
                  className="quantity-input"
                  placeholder={`Máx: ${salePointData.current_quantity}`}
                />
                {warningMessage && <p className="warning-text">{warningMessage}</p>}
              </div>
            </div>
            <div className="move-row2">
              <span className="move-label">Punto de venta:</span>
              <div className="move-value">
                <FormControl fullWidth>
                  <Select
                    value={selectedModalSalePoint || ''}
                    onChange={onModalSalePointChange}
                    className="salepoint-selector"
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Seleccionar punto de venta
                    </MenuItem>
                    {salePoints
                      .filter(salePoint => salePoint.value !== salePointData.sale_point_id)
                      .map((salePoint, i) => (
                        <MenuItem key={i} value={salePoint.value}>
                          {salePoint.label}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>
        </div>

      );
    }
  };

  // const CustomModal = ({ title, message, onConfirm, onCancel }) => {
  //   return (
  //     <div className="modal-container">
  //       <div className="modal-content">
  //         <h2>{title}</h2>
  //         <p>{message}</p>
  //         <div className="modal-buttons">
  //           <button className="btn-confirm" onClick={onConfirm}>Sí</button>
  //           <button className="btn-cancel" onClick={onCancel}>Cancelar</button>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };
  
  return (
    <>
      {/* Main Modal */}
      <Modal open={isOpen}>
        <Box display="flex" justifyContent="center" alignItems="center" width="100%" height="100%">
          <div className="bg-white rounded p-4 move-product-modal">
            {renderTabContent()}
            <div className="modal-options-move">
              <Button variant="text" color="primary" onClick={onClose} className="cancel-button">
                Cancelar
              </Button>
              <BlueButton variant="contained" color="primary" onClick={handleSave} className="blue-button">
                <span>Guardar</span>
              </BlueButton>
            </div>
          </div>
        </Box>
      </Modal>

      {/* confirmation modal */}
      <Modal open={showConfirmModal} onClose={() => setShowConfirmModal(false)}>
        <Box display="flex" justifyContent="center" alignItems="center" width="100%" height="100%">
          <div className="bg-white rounded p-4 move-confirmation-transfer-modal">
            <h2 className="modal-title">Confirmar Traslado</h2>
            <p>¿Estás seguro de que deseas trasladar estos productos?</p>

            {/* detail table */}
            <div className="transfer-details">
              <span className="detail-label">Producto:</span>
              <span className="detail-value">{salePointData?.name}</span>

              <span className="detail-label">Cantidad a trasladar:</span>
              <span className="detail-value">{quantity}</span>

              <span className="detail-label">Origen: </span>
              <span className="detail-value">{salePointData.sale_point_name}</span>

              <span className="detail-label">Destino:</span>
              <span className="detail-value">
                {salePoints.find(sp => sp.value === selectedModalSalePoint)?.label || 'N/A'}
              </span>
            </div>

            {/* action Buttons*/}
            <div className="modal-options-move">
              <Button variant="text" color="primary" onClick={() => setShowConfirmModal(false)} className="cancel-button" disabled={isLoading}>
                No, volver
              </Button>
              <BlueButton
                variant="contained"
                color="primary"
                onClick={handleConfirmTransfer}
                className="blue-button"
                disabled={isLoading}
              >
                {isLoading ? <CircularProgress size={24} color="inherit" /> : "Trasladar"}
              </BlueButton>
            </div>
          </div>
        </Box>
      </Modal>

      {/* result modal */}
      <Modal open={showResultModal} onClose={() => setShowResultModal(false)}>
        <Box display="flex" justifyContent="center" alignItems="center" width="100%" height="100%">
          <div className="bg-white rounded p-4 move-result-transfer-modal">
            <h2 className="modal-title">Resultado del Traslado</h2>
            <p style={{ marginTop: '20px', marginBottom: '40px' }}>{resultMessage}</p>
            <div className="modal-options-move">
              <Button variant="contained" color="primary" onClick={() => {
                setShowResultModal(false);
                onClose();
                setTimeout(() => window.location.reload(), 200);
                // window.location.reload();
              }}>
                Cerrar
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );


};

export default MoveProductModal;

